"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assert;

// Replacement for the external assert method to reduce bundle size
// Note: We don't use the second "message" argument in calling code,
// so no need to support it here
function assert(condition) {
  if (!condition) {
    throw new Error('viewport-mercator-project: assertion failed.');
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/viewport-mercator-project/dist/es5/assert.js
// module id = 273
// module chunks = 35783957827783